import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IconButton, Select, MenuItem, InputLabel, FormControl, Checkbox, FormControlLabel } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { toast } from 'react-toastify';
import Grow from '@material-ui/core/Grow';
import moment from "moment";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} />;
});

const initialFormState = { 
	id: null,
  mobile: "",
  firstname: "",
  lastname: "",
  email: "",
  birthday: moment().format("YYYY-MM-DD"),
  tenants: [],
  spam: false,
}

const FormDialogEditLabel = (props) => {
  const [open, setOpen] = useState(false);
  const [label, setLabel] = useState(initialFormState);
  const [errors, setErrors ] = useState({})

  const handleClickOpen = () => {
      setErrors({});
      setLabel({
        id : props.dataLabel[0],
        mobile: props.dataLabel[1],
        firstname : props.dataLabel[2],
        lastname : props.dataLabel[3],
        email : props.dataLabel[4],
        birthday : props.dataLabel[5],
        tenants: props.dataLabel[6],
        spam: props.dataLabel[7],
      })
      setOpen(true);
  }

  const handleClose = () => {
      setOpen(false);
  }

  const handleInputChange = event => {
		const { name, value } = event.target
    setLabel({ ...label, [name]: value })
  }
  
  const validate = () => {
    let tempErrors = {};
    let formIsValid = true;
    if (!label.mobile || label.mobile.trim() === "") {
      formIsValid = false;
      tempErrors["mobile"] = "Cannot be empty";
    }
    if (!label.firstname || label.firstname.trim() === "") {
      formIsValid = false;
      tempErrors["firstname"] = "Cannot be empty";
    }
    if (!label.lastname || label.lastname.trim() === "") {
      formIsValid = false;
      tempErrors["lastname"] = "Cannot be empty";
    }

    setErrors(tempErrors);
    return formIsValid;
  }


  const handleSubmit = (e) => {
      const onSuccess = () => {
          setOpen(false);
          toast.success('Data succesfully updated');
      }
      e.preventDefault();

      if(validate()){
        props.update(label.id, label, onSuccess)
      }
  }

  return (
    <div>
      <IconButton color="primary" onClick={handleClickOpen}>
          <EditIcon />
      </IconButton>
      <Dialog  
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        aria-labelledby="form-dialog-title"
      >
            <DialogTitle id="form-dialog-title" style={{padding: "30px 30px 0px 30px"}}>Edit Label</DialogTitle>

            <DialogContent style={{ padding: "30px 30px 10px 30px" }}>
          
          <div className="row">
          <div className="col-lg-6 col-12">
              <TextField

                name="mobile"
                label="Mobile"
                value={label.mobile}
                fullWidth
                onChange={handleInputChange}
                {...(errors.mobile && { error: true, helperText: errors.mobile })}
                style={{ marginBottom: 25 }}
              />
            </div>
            <div className="col-lg-6 col-12">
              <TextField
                autoFocus
                name="firstname"
                label="First Name"
                value={label.firstname}
                fullWidth
                onChange={handleInputChange}
                {...(errors.firstname && { error: true, helperText: errors.firstname })}
                required
                style={{ marginBottom: 15 }}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-lg-6 col-12">
              <TextField

                name="lastname"
                label="Last Name"
                value={label.lastname}
                fullWidth
                onChange={handleInputChange}
                {...(errors.lastname && { error: true, helperText: errors.lastname })}
                required
                style={{ marginBottom: 15 }}
              />
            </div>
            <div className="col-lg-6 col-12">
              <TextField
                name="email"
                label="Email"
                value={label.email}
                fullWidth
                onChange={handleInputChange}
                {...(errors.email && { error: true, helperText: errors.email })}
                required
                style={{ marginBottom: 15 }}
              />
            </div>
          </div>
        
          <div className="row">
          <div className="col-lg-12 col-12 mb-3">
          <TextField
          type="date"
                name="birthday"
                label="DOB"
                value={moment(label.birthday).format("YYYY-MM-DD")}
                fullWidth
                onChange={handleInputChange}
                {...(errors.birthday && { error: true, helperText: errors.birthday })}
                required
                style={{ marginBottom: 15 }}
              />
            </div>
            <div className="col-lg-12 col-12 mb-3">
              <FormControl
                fullWidth={true}
              >
                <InputLabel id="demo-simple-select-label">Spam</InputLabel>
                <Select
                  name="spam"
                  label="Spam"
                  value={label.spam}
                  onChange={handleInputChange}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="col-lg-12 col-12">
              <FormControl
                fullWidth={true}
              >
                <InputLabel id="demo-simple-select-label">Organizations</InputLabel>
                <Select
                  name="tenants"
                  label="tenants"
                  value={label.tenants}
                  onChange={handleInputChange}
                  multiple
                >
                  {props.tenants.map(item => (
                    <MenuItem value={item.id}>{item.name}</MenuItem>
                  ))}

                </Select>
              </FormControl>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-12">

            </div>
            <div className="col-lg-6 col-12">

            </div>
          </div>


        </DialogContent>

            <DialogActions style={{padding: 30}}>
                <Button variant="contained" onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button variant="contained" onClick={handleSubmit} color="secondary">
                    Save
                </Button>
            </DialogActions>

      </Dialog>
    </div>
  );
}

export default FormDialogEditLabel;